export default () => ({
  openOrder: null,
  orders: {
    items: [],
  },
  show_no_orders_string: false,
  formatDate(dateString) {
    const date = new Date(dateString);
    const transformedDate = date.toISOString().split("T")[0];
    return transformedDate;
  },
  fetchOrders() {
    const url = `${shopUrl}/apps/jl-api/frontend/voyado/transactions`;
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        this.orders = data;
        console.log(data);
      });
  },
  fetchOrderData(transactionNumber, orderIndex, currency) {
    const url = `${shopUrl}/apps/jl-api/frontend/shopify/order/name/${transactionNumber}?fields=id,line_items,name,processed_at,created_at,total_price,total_discounts,total_shipping_price_set,shipping_address,fulfillment_status,customer,shipping_lines,payment_gateway_names,subtotal_price`;
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        let id = "";
        if (orderIndex == 1) {
          id = `order-${orderIndex}`;
        } else {
          id = `order-${orderIndex}-${orderIndex - 1}`;
        }
        let wrapper = document.getElementById(id);
        let itemWrapper = wrapper.querySelector(".item-wrapper");

        if (
          !wrapper
            .querySelector(".details-method")
            .innerText.includes(data.shipping_lines[0].title)
        ) {
          // set shipping details
          wrapper.querySelector(
            ".details-method"
          ).innerText += ` ${data.shipping_lines[0].title}`;
          wrapper.querySelector(
            ".details-payment"
          ).innerText += ` ${data.payment_gateway_names[0]}`;
          wrapper.querySelector(
            ".details-sent"
          ).innerText += ` ${this.formatDate(data.processed_at)}`;

          // set shipping address
          wrapper.querySelector(
            ".address-name"
          ).innerText += `${data.shipping_address.name}`;
          wrapper.querySelector(
            ".address-street"
          ).innerText += `${data.shipping_address.address1}`;
          wrapper.querySelector(
            ".address-city"
          ).innerText += `${data.shipping_address.city}`;
          wrapper.querySelector(
            ".address-phone"
          ).innerText += `${data.shipping_address.phone}`;

          // set order total
          wrapper.querySelector(
            ".order-subtotal"
          ).innerText += `${this.setPrice(data.subtotal_price, currency)}`;
          wrapper.querySelector(
            ".order-shipping"
          ).innerText += `${this.setPrice(
            data.total_shipping_price_set.shop_money.amount,
            currency
          )}`;
          wrapper.querySelector(
            ".order-discount"
          ).innerText += `${this.setPrice(data.total_discounts, currency)}`;
          wrapper.querySelector(".order-total").innerText += `${this.setPrice(
            data.total_price,
            currency
          )}`;
        }

        data.line_items.forEach((item, itemIndex) => {
          const prodHandle = item.title
            .toLowerCase()
            .replace(/\s/g, "-")
            .replace(/\//g, "")
            .replace(/\s+/g, "-")
            .replace(/[^a-zA-Z0-9-]/g, "")
            .replace(/-{2,}/g, "-");

          fetch(`${shopUrl}/products/${prodHandle}.js`)
            .then((response) => response.json())
            .then((variantData) => {
              let className = `item-${itemIndex}`;

              let itemEl = itemWrapper.querySelector(`.${className}`);
              itemEl.querySelector(".item-img").src =
                variantData.featured_image;
            });
        });
      });
  },
  fetchStatus(transactionNumber, orderIndex, storeName, storeType) {
    if (storeType == "ecomm") {
      const url = `${shopUrl}/apps/jl-api/frontend/shopify/order/name/${transactionNumber}?fields=fulfillment_status,fulfillments`;
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          let id = "";
          let wrapperId = "";

          if (orderIndex == 1) {
            id = `status-${orderIndex}`;
            wrapperId = `order-${orderIndex}`;
          } else {
            id = `status-${orderIndex}-${orderIndex - 1}`;
            wrapperId = `order-${orderIndex}-${orderIndex - 1}`;
          }
          if (data.fulfillment_status != "fulfilled") {
            document.getElementById(id).color = "#000";
          }

          document.getElementById(id).innerText = data.fulfillment_status;

          let wrapper = document.getElementById(wrapperId);
          let trackBtn = wrapper.querySelector(".narvar-track-btn");

          let trackingCompany = data.fulfillments[0].tracking_company;
          let trackingNumber = data.fulfillments[0].tracking_number;

          if (trackingCompany == "PLAB") {
            trackingCompany = "postnord";
          }

          let orderUrl = `https://narvar.com/tracking/jlindeberg/${trackingCompany}?tracking_numbers=${trackingNumber}`;
          trackBtn.href = orderUrl;
        });
    } else {
      let id = "";
      let wrapperId = "";

      if (orderIndex == 1) {
        id = `status-${orderIndex}`;
        wrapperId = `order-${orderIndex}`;
      } else {
        id = `status-${orderIndex}-${orderIndex - 1}`;
        wrapperId = `order-${orderIndex}-${orderIndex - 1}`;
      }

      let trackBtn = wrapper.querySelector(".narvar-track-btn");
      trackBtn.style.display = "none";
      document.getElementById(id).innerText = storeName;
    }
  },
  setPrice(price, currency) {
    const fixedPrice = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currency,
    }).format(parseFloat(~~price));

    return fixedPrice.replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
  },
  setUrl(name) {
    const prodHandle = name
      .toLowerCase()
      .replace(/\s/g, "-")
      .replace(/\//g, "")
      .replace(/\s+/g, "-")
      .replace(/[^a-zA-Z0-9-]/g, "")
      .replace(/-{2,}/g, "-");

    return `${shopUrl}/products/${prodHandle}`;
  },
  countOrders(value) {
    const list = document.getElementById("orders-list");
    setTimeout(() => {
      if (list.clientHeight == 0) {
        this.show_no_orders_string = true;
      } else {
        this.show_no_orders_string = false;
      }
    }, 100);
  },
});
